module.exports = __webpack_public_path__ + "static/media/slack_icon.6c896bd2.png";